import { httpClient } from '../http-client'
import type { ClientFilesParams, ClientFilesResponse, UploadFileParams, UploadFileResponse } from '@/types/api'

/**
 * AttachmentService - Gerencia uploads e arquivos de usuários
 */
class AttachmentService {
  async getClientFiles(clientId: string, params?: ClientFilesParams): Promise<ClientFilesResponse> {
    const response = await httpClient.get(`/clients/files/${clientId}`, { params })
    return response.data
  }

  async deleteFile(fileId: string) {
    const response = await httpClient.delete(`/files/${fileId}`)
    return response.data
  }

  async downloadFile(fileId: string) {
    const response = await httpClient.get(`/files/${fileId}/download`, {
      responseType: 'blob',
    })
    return response.data
  }

  async uploadFile(clientId: string, params: UploadFileParams): Promise<UploadFileResponse> {
    const formData = new FormData()
    formData.append('file', params.file)

    if (params.fileName) {
      formData.append('fileName', params.fileName)
    }

    if (params.parentFolderId) {
      formData.append('parentFolderId', params.parentFolderId)
    }

    if (params.isSystemFile !== undefined) {
      formData.append('isSystemFile', String(params.isSystemFile))
    }

    const response = await httpClient.post(`/clients/upload-file/${clientId}`, formData)
    return response.data
  }

  async uploadAvatar(mentorId: string, file: File, fileName: string): Promise<UploadFileResponse> {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', fileName)
    formData.append('isSystemFile', 'true')

    const response = await httpClient.post(`/clients/upload-file/${mentorId}`, formData)
    return response.data
  }
}

export const attachmentService = new AttachmentService()
